import React from 'react';
import PropTypes from 'prop-types';
import PlayerHeader from './components/PlayerHeader';
import InfoBar from './components/InfoBar';
import DataList from './components/DataList';
import * as S from './styles';

export default function PlayerInfo({ value, onClose, isLocal, shield }) {
  return (
    <S.Container>
      <PlayerHeader
        {...value}
        onClose={onClose}
        isLocal={isLocal}
        shield={shield}
      />
      <InfoBar {...value} onClose={onClose} isLocal={isLocal} />
      <DataList data={value} onClose={onClose} isLocal={isLocal} />
    </S.Container>
  );
}

PlayerInfo.propTypes = {
  value: PropTypes.object,
  onClose: PropTypes.func,
  isLocal: PropTypes.bool,
  shield: PropTypes.string,
};

PlayerInfo.defaultProps = {
  value: {},
  onClose: () => {},
  isLocal: false,
  shield: '',
};
